import {useState, useEffect, useCallback} from "react";

import {Card, Button, Col, Row, Container} from "react-bootstrap";
import {LoadingSpinner} from "../ui/LoadingSpinner";
import {useAuth} from "../auth/AuthProvider"
import {getAlertNotifications} from "../../lib/api/getAlertNotifications";
import {JsonPopup} from "../ui/JsonPopup";
import {callProcessNotifications} from "../../lib/backend/callProcessNotifications";


export function AlertNotificationsQueue({signal}) {
    const [isLoading, setIsLoading] = useState(true);
    const [isContactingBE, setIsContactingBE] = useState(false);
    const [notificatonsCount, setNotificatonsCount] = useState(0);
    const [alertNotificationsJson, setAlertNotificationsJson] = useState({});

    const {token} = useAuth();

    const loadNotifications = () => {
        setIsLoading(true);
        getAlertNotifications(token).then( (data) => {
            setNotificatonsCount(data["count"]);
            setAlertNotificationsJson(data["notifications"]);
        }).catch( (err) => {
            console.error(err);
        }).finally( () => {
            setIsLoading(false);
        })
    }

    useEffect(() => {
        if (token) {
          loadNotifications();
        }
    }, [token]);

    useEffect(() => {
        if (signal === "reset") {
            loadNotifications();
        }
    }, [signal]);

    const handleCallProcessEvents = () => {
        setIsContactingBE(true);
        callProcessNotifications().then( (data) => {
            setTimeout(() => {
                loadNotifications();
                setIsContactingBE(false);
            }, 1500);
        }).catch( (err) => {
            console.error(err);
            setIsContactingBE(false);
        })
    }


    return (
        <Card>
            <Card.Body>
                <Card.Title>Alert Notifications Queue</Card.Title>
                <Container>
                    Notifcations in DB: <LoadingSpinner loadingFlag={isLoading}> {notificatonsCount}
                    { (notificatonsCount > 0) && <>
                        &nbsp; <JsonPopup jsonData={alertNotificationsJson} buttonLabel={"Show"} />
                        <LoadingSpinner loadingFlag={isContactingBE}>
                            &nbsp; <Button onClick={handleCallProcessEvents}>Call Process events</Button>
                        </LoadingSpinner>


                    </> }
                </LoadingSpinner>

                </Container>
            </Card.Body>
        </Card>
    )
}